(() => {
  const normalizeOptions = (product) => (product.options || []).map((option) => {
    if (typeof option === 'string') return option;
    return option?.name || option?.value || '';
  });

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const init = (root) => {
    if (!root || root.dataset.jbScentStepReady === 'true') return;
    root.dataset.jbScentStepReady = 'true';

    const form = root.querySelector('[data-jb-product-form]');
    const dataNode = root.querySelector('[data-jb-product-json]');
    if (!form || !dataNode) return;

    let product;
    try {
      product = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('JerrBear product data could not be read.', error);
      return;
    }

    const optionNames = normalizeOptions(product);
    const selects = Array.from(form.querySelectorAll('[data-jb-option-position]'));
    const variantInput = form.querySelector('[data-jb-variant-id]');
    const standardButton = form.querySelector('[data-jb-standard-add]');
    const stepButton = form.querySelector('[data-jb-start-scent-step]');
    const quantityInput = form.querySelector('[data-jb-quantity]');
    const priceNode = root.querySelector('[data-jb-product-price]');
    const skuNode = root.querySelector('[data-jb-product-sku]');

    const selectedByPosition = () => {
      const values = {};
      selects.forEach((select) => {
        values[Number(select.dataset.jbOptionPosition)] = select.value;
      });
      return values;
    };

    const variantMatches = (variant, selected) => Object.entries(selected).every(([position, value]) => {
      return String(variant.options?.[Number(position) - 1] ?? '') === String(value);
    });

    const updateProductState = () => {
      const selected = selectedByPosition();
      const candidates = (product.variants || []).filter((variant) => variantMatches(variant, selected));
      const variant = candidates.find((item) => item.available) || candidates[0];
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceNode && Number.isFinite(Number(variant.price))) priceNode.textContent = formatMoney(variant.price);
      if (skuNode) skuNode.textContent = variant.sku ? `SKU: ${variant.sku}` : '';

      if (standardButton) {
        standardButton.disabled = !variant.available;
        const label = standardButton.childNodes[0];
        if (label) label.nodeValue = variant.available ? ' Add to Cart ' : ' Sold Out ';
      }
    };

    selects.forEach((select) => select.addEventListener('change', updateProductState));
    updateProductState();

    if (!stepButton) return;

    stepButton.addEventListener('click', () => {
      const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const selected = selectedByPosition();
      const handle = root.dataset.productHandle || product.handle;
      if (!handle) return;

      try {
        sessionStorage.setItem(`jb-scent-product:${handle}`, JSON.stringify(product));
      } catch (_) {
        // The selector page has a network fallback if browser storage is unavailable.
      }

      const params = new URLSearchParams();
      params.set('product', handle);
      params.set('quantity', String(quantity));
      params.set('return', product.url || window.location.pathname);
      params.set('scent_position', stepButton.dataset.scentOptionPosition || '0');
      Object.entries(selected).forEach(([position, value]) => params.set(`option${position}`, value));

      const currentParams = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_ab', '_fd', '_sc'].forEach((key) => {
        if (currentParams.has(key)) params.set(key, currentParams.get(key));
      });

      const rootUrl = window.Shopify?.routes?.root || '/';
      window.location.assign(`${rootUrl}pages/select-fragrance?${params.toString()}`);
    });
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-jb-product-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
